var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticClass:"foot-area"},[_c('el-col',{attrs:{"span":24}},[_vm._v("练习进度: "+_vm._s((_vm.current!=null?_vm.current:0)+1)+"/"+_vm._s(_vm.total!=null?_vm.total:1))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }